<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiBookOpenPageVariantOutline } from '@mdi/js';

export default {
  name: "IconPages",
  components: {
    SvgIcon
  },
  data() {
    return {
       path: mdiBookOpenPageVariantOutline,
    }
  }
}
</script>